<!--
 * @Author: rzdata
 * @Date: 2026-07-28
 * @Description: UDI下载记录抽屉组件
-->
<template>
    <el-drawer title="下载记录" :visible.sync="drawerVisible" size="1200px" direction="rtl">
    <div class="drawer-content">
      <el-table ref="table" border :data="recordList" :height="tableHeight" style="width:100%">
        <el-table-column prop="fileName" label="文件名" show-overflow-tooltip min-width="180" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{row}">
            <el-tag v-if="row.status === 0" type="warning">生成中</el-tag>
            <el-tag v-else-if="row.status === 1" type="success">成功</el-tag>
            <el-tag v-else-if="row.status === 2" type="danger">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="errorMsg" label="错误信息" show-overflow-tooltip min-width="150" />
        <el-table-column prop="createBy" label="操作人" width="120" />
        <el-table-column prop="downloadDate" label="下载日期" width="160">
          <template slot-scope="{row}">
            {{ row.downloadDate ? parseTime(row.downloadDate) : null }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" :disabled="row.status !== 1" @click="handleDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getRecordList"
        :small="true"
      />
    </div>
  </el-drawer>
</template>

<script>
import { getDownloadRecordList, downloadUdiFile } from '@/api/orderManage'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'DownloadDrawer',
  data() {
    return {
      drawerVisible: false,
      recordList: [],
      total: 0,
      tableHeight: window.innerHeight - 200 + 'px',
      queryParams: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    parseTime,
    open() {
      this.drawerVisible = true
      this.queryParams.pageNum = 1
      this.getRecordList()
    },
    async getRecordList() {
      try {
        const res = await getDownloadRecordList(this.queryParams)
        if (res.code === 200) {
          this.recordList = res.rows || []
          this.total = res.total || 0
        }
      } catch (error) {
        console.error('获取下载记录失败', error)
      }
    },
    async handleDownload(row) {
      try {
        const res = await downloadUdiFile(row.id)
        if (res) {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(res)
          link.download = row.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(link.href)
          this.$message.success('下载成功')
        }
      } catch (error) {
        console.error('下载失败', error)
        this.$message.error('下载失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.drawer-content {
  padding: 20px;
}
</style>
